import React from 'react';
import DefaultSimManuelRecipient from '../components/ManulRecipient/DefaultSimManuelRecipient';
import { iban } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const Sim_F07_RequestPaymentToIBANManually = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <DefaultSimManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
    manualName={iban}
  />
);

export default Sim_F07_RequestPaymentToIBANManually;
